var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPublishedStageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1525_32553",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.83447,
    y: 5.83368,
    width: 19.3333,
    height: 19.3333,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1525_32553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2319 20.0114C11.1245 20.0114 11.0238 19.9912 10.9298 19.9509C10.8358 19.9107 10.7485 19.8502 10.668 19.7697L7.2645 16.3662C7.11681 16.2185 7.04297 16.0271 7.04297 15.7919C7.04297 15.5572 7.11681 15.366 7.2645 15.2183C7.41218 15.0706 7.60014 14.9968 7.82839 14.9968C8.05663 14.9968 8.24459 15.0706 8.39227 15.2183L12.3798 19.2058L11.7957 19.7697C11.7152 19.8502 11.6279 19.9107 11.5339 19.9509C11.44 19.9912 11.3393 20.0114 11.2319 20.0114ZM15.7832 19.9912C15.6758 19.9912 15.5751 19.9743 15.4812 19.9405C15.3872 19.9072 15.2999 19.8502 15.2194 19.7697L11.7957 16.3461C11.6481 16.1984 11.5742 16.0069 11.5742 15.7717C11.5742 15.537 11.6481 15.3458 11.7957 15.1982C11.9434 15.0505 12.1314 14.9766 12.3596 14.9766C12.5879 14.9766 12.7758 15.0505 12.9235 15.1982L15.7832 18.0579L22.6305 11.2107C22.7782 11.063 22.9661 10.9891 23.1944 10.9891C23.4226 10.9891 23.6106 11.063 23.7582 11.2107C23.9059 11.3583 23.9798 11.5495 23.9798 11.7842C23.9798 12.0194 23.9059 12.2109 23.7582 12.3586L16.3471 19.7697C16.2666 19.8502 16.1793 19.9072 16.0853 19.9405C15.9913 19.9743 15.8907 19.9912 15.7832 19.9912ZM15.7832 15.7822L14.6353 14.6544L18.0589 11.2308C18.2066 11.0831 18.3978 11.0093 18.6325 11.0093C18.8677 11.0093 19.0592 11.0831 19.2069 11.2308C19.3545 11.3785 19.4284 11.5665 19.4284 11.7947C19.4284 12.0229 19.3545 12.2109 19.2069 12.3586L15.7832 15.7822Z",
    fill: "#C2C2C2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPublishedStageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PublishedStageIcon.fef3f66d.svg";
export { ForwardRef as ReactComponent };